// extracted by mini-css-extract-plugin
export default {"container":"bfcI18","title":"puqoT0","text":"EpNqLq","button":"NOuJsc"};